import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Link as RLink } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

import Dialog, { DialogProps } from '@mui/material/Dialog';

import { Page,  selectPages } from './pageSlice';
import { Tags } from '../tag/Tags';


interface ChildProps {
	page: Page | null;
	onPost: () => void;
}

export default function PageEditToolBar( {page, onPost}: ChildProps ) {
	const sx = {
		backgroundColor: '#eeeeee',
		display: 'flex',
		height: 45,
		width: '100%',
		paddingLeft: 6,
		paddingRight: 10,
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 1,
		//backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};
	const pageIdLink = page ? "/page/view/" + page.metadata.id : "";
	return (
		<Box position="fixed" sx={sx}>
			<Tags />
			<Box sx={sxleft}>
				<Typography>Pages</Typography>
			</Box>
			<Box sx={sxright}>
				<Link component={RLink} to={pageIdLink}>
					<Button
						variant="outlined"
						startIcon={<AddIcon />}
						size="small"
						onClick={onPost}
					>
						Cancel
					</Button>
				</Link>
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
					onClick={onPost}
				>
					Save
				</Button>
			</Box>
		</Box>
	)
}

